import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../context/GlobalContext";

function MyRol(props) {
    
    const {lang} = useContext(GlobalContext)
    console.log(props.rol);

    let t = []

    
    return(
        <div className="myRol projDet" id="myRol-det">
            
            <p className="myRol__rol">{props.rol}</p>
            
            {props.tasks.length === 0 
            
            ? 
            
            null 
            
            : 
                <ul className="myRol__tasksList"><span>{lang === "ingles" ? "Tasks: " : "Tareas: "}</span>
                    {props.tasks.map((task) => {
                        return(
                            <li className="myRol__task"><p>{task}</p></li>
                        )
                    })}
                </ul>
            }
        </div>
    )
}

export default MyRol